
export default function About() {
  const stats = [
    { value: '20+', label: '年行業經驗' },
    { value: '100+', label: '跨專業醫護人員' },
    { value: '50+', label: '服務院舍夥伴' },
    { value: '98%', label: '院舍客戶滿意度' },
  ];

  const highlights = [
    {
      icon: 'ri-team-line',
      title: '跨專業治療師團隊',
      desc: '由持牌物理治療師、職業治療師及言語治療師組成，為院舍提供穩定、合規的外展復康服務，確保院友獲得專業照護。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '合規專業保障',
      desc: '所有治療師均持有香港認可專業牌照，服務符合社署及衛生署最新規定，助院舍輕鬆通過審查及評級。',
    },
    {
      icon: 'ri-robot-line',
      title: '智能器材供應',
      desc: '提供先進復康訓練器材及智能監測系統，並協助院舍申請樂齡科技基金及康復創科應用基金，最高資助達 $500,000。',
    },
    {
      icon: 'ri-tools-line',
      title: '院舍改善工程',
      desc: '針對政府最新人均面積及設施標準，提供空間規劃、牌照顧問及工程施工一條龍服務，助院舍順利完成升級。',
    },
    {
      icon: 'ri-file-list-3-line',
      title: '資助申請支援',
      desc: '熟悉各項政府資助計劃，全程協助院舍完成申請文件及跟進審批，大幅降低院舍的營運及升級成本。',
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '全程顧問支援',
      desc: '從需求評估、方案設計到落地執行，我們的顧問團隊全程陪伴，確保每個解決方案切實符合院舍的實際需要。',
    },
  ];

  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      {/* 背景裝飾 */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-50 rounded-full -translate-y-1/2 translate-x-1/2 opacity-60"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-orange-50 rounded-full translate-y-1/2 -translate-x-1/2 opacity-60"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">

        {/* 標題區域 */}
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 bg-orange-500 rounded-full mb-6">
            <span className="text-sm font-bold text-white tracking-wider">關於我們</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            關於康顧
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-orange-600 mx-auto mb-8"></div>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed">
            康顧是院舍營運者的專業夥伴，透過跨專業治療團隊、智能器材及工程改善服務，協助私營院舍、NGO及長者日間中心提升服務質素與競爭力。
          </p>
        </div>

        {/* 圖文介紹 */}
        <div className="flex flex-col lg:flex-row gap-12 items-center mb-24">
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <div className="w-full h-[480px]">
                <img
                  src="https://public.readdy.ai/ai/img_res/edited_9c5ec26df34aec1f5678d2f2938b1ab5_a8262640.jpg"
                  alt="康顧跨專業醫護團隊"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              {/* 浮動標籤 */}
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-white/90 backdrop-blur-sm rounded-2xl px-6 py-4 flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-orange-500 rounded-full">
                    <i className="ri-award-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <p className="font-bold text-slate-900 text-sm">香港認可跨專業復康服務機構</p>
                    <p className="text-slate-500 text-xs">社會福利署認可 · 業界信賴夥伴</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2 space-y-6">
            <h3 className="text-3xl font-bold text-slate-900 leading-snug">
              院舍營運者的<br />
              <span className="text-orange-500">最強專業後盾</span>
            </h3>
            <p className="text-slate-600 leading-relaxed text-lg">
              康顧由<strong className="text-orange-600">一支擁有逾20年行業經驗的管理團隊領航</strong>，並以逾<strong className="text-orange-600">100人的跨專業醫護團隊</strong>為堅實後盾，深諳院舍營運的各種挑戰。
            </p>
            <p className="text-slate-600 leading-relaxed text-lg">
              我們的客戶包括<strong className="text-orange-600">私營院舍、NGO及長者日間中心</strong>。我們深明院舍在人手招募、合規要求及設施升級方面面對的重重壓力，因此提供一站式解決方案，讓院舍管理者專注於核心業務。
            </p>
            <p className="text-slate-600 leading-relaxed text-lg">
              透過三大核心業務——<strong className="text-orange-600">復康外展服務、智能器材供應及院舍改善工程</strong>，我們協助院舍提升服務質素、符合監管要求，並善用政府資助，全面提升競爭力。
            </p>
            <div className="flex gap-4 pt-2">
              <a
                href="#services"
                className="inline-flex items-center bg-orange-500 text-white font-bold px-6 py-3 rounded-full hover:bg-orange-600 transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer"
              >
                <span>了解我們的服務</span>
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="/contact"
                className="inline-flex items-center border-2 border-orange-500 text-orange-500 font-bold px-6 py-3 rounded-full hover:bg-orange-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <span>立即查詢</span>
              </a>
            </div>
          </div>
        </div>

        {/* 數據統計 */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-24">
          {stats.map((stat, i) => (
            <div key={i} className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl p-8 text-center shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <p className="text-4xl md:text-5xl font-bold text-white mb-2">{stat.value}</p>
              <p className="text-orange-100 font-medium text-sm">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* 六大服務優勢 */}
        <div className="text-center mb-12">
          <h3 className="text-3xl font-bold text-slate-900 mb-4">為何選擇康顧？</h3>
          <p className="text-slate-500 max-w-xl mx-auto">我們以專業、誠信及創新，成為院舍最可靠的長期合作夥伴</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-24">
          {highlights.map((item, i) => (
            <div key={i} className="group bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-orange-100 hover:border-orange-400">
              <div className="w-14 h-14 flex items-center justify-center bg-orange-50 group-hover:bg-orange-500 rounded-xl mb-5 transition-colors duration-300">
                <i className={`${item.icon} text-2xl text-orange-500 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h4 className="text-xl font-bold text-slate-900 mb-3">{item.title}</h4>
              <p className="text-slate-600 leading-relaxed text-sm">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* 四大核心價值 */}
        <div className="text-center mb-12">
          <h3 className="text-3xl font-bold text-slate-900 mb-4">我們的核心價值</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {[
            { icon: 'ri-shield-check-line', title: '安全', sub: 'SAFETY', desc: '確保每一項服務符合最高安全標準，為院舍提供安心可靠的專業支援' },
            { icon: 'ri-hand-heart-line', title: '誠信', sub: 'INTEGRITY', desc: '以誠信為本，建立長期信任關係，成為院舍最可靠的合作夥伴' },
            { icon: 'ri-trophy-line', title: '卓越', sub: 'EXCELLENCE', desc: '追求專業卓越，持續創新，提供業界領先的優質服務' },
            { icon: 'ri-team-line', title: '以人為本', sub: 'PEOPLE-CENTRIC', desc: '關注院舍及其院友的實際需求，提供個人化、有溫度的專業服務' },
          ].map((val, i) => (
            <div key={i} className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-orange-500">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${val.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-1">{val.title}</h3>
              <p className="text-orange-400 text-xs font-semibold tracking-widest mb-3">{val.sub}</p>
              <p className="text-slate-600 leading-relaxed text-sm">{val.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
